import { useState, useEffect } from 'react';
import { useApp } from '../App';
import api from '../utils/api';

export default function Users() {
  const { user:me, toast } = useApp();
  const [users,setUsers]     = useState([]);
  const [loading,setLoading] = useState(true);
  const [modal,setModal]     = useState(false);
  const [editing,setEditing] = useState(null);
  const [form,setForm]       = useState({ name:'',email:'',password:'',role:'sales' });
  const [saving,setSaving]   = useState(false);
  const [pwModal,setPwModal] = useState(null);
  const [newPw,setNewPw]     = useState('');

  const load = async () => {
    setLoading(true);
    try { setUsers(await api.get('/users')); }
    catch(e) { toast(e.message,'error'); }
    finally { setLoading(false); }
  };
  useEffect(()=>{ load(); },[]);

  const openAdd  = ()  => { setEditing(null); setForm({ name:'',email:'',password:'',role:'sales' }); setModal(true); };
  const openEdit = (u) => { setEditing(u); setForm({ name:u.name,email:u.email,password:'',role:u.role }); setModal(true); };

  const save = async () => {
    if (!form.name||!form.email) { toast('Name and email required','error'); return; }
    if (!editing&&!form.password) { toast('Password required','error'); return; }
    setSaving(true);
    try {
      if (editing) {
        const payload = { name:form.name,email:form.email,role:form.role };
        if (form.password) payload.password = form.password;
        await api.patch(`/users/${editing.id}`, payload);
        toast('User updated','success');
      } else {
        await api.post('/users', form);
        toast('User created: '+form.name,'success');
      }
      setModal(false); load();
    } catch(e) { toast(e.message,'error'); }
    finally { setSaving(false); }
  };

  const toggleActive = async (u) => {
    try {
      await api.patch(`/users/${u.id}`, { active:!u.active });
      toast(u.active?'User deactivated':'User activated','success');
      load();
    } catch(e) { toast(e.message,'error'); }
  };

  const resetPw = async () => {
    if (!newPw||newPw.length<6) { toast('Min. 6 characters','error'); return; }
    try {
      await api.patch(`/users/${pwModal.id}`, { password:newPw });
      setPwModal(null); setNewPw('');
      toast('Password reset','success');
    } catch(e) { toast(e.message,'error'); }
  };

  const initials = name => name.split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase();

  return (
    <div className="animate-fade-up">
      <div className="page-header">
        <div>
          <div className="page-eyebrow">Team</div>
          <div className="page-title">Users</div>
          <div className="page-sub">Manage team access and roles</div>
        </div>
        <button className="btn btn-copper" onClick={openAdd}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 5v14M5 12h14"/></svg>
          Add user
        </button>
      </div>

      <div className="table-wrap">
        <table className="table">
          <thead>
            <tr>
              <th>User</th>
              <th>Email</th>
              <th>Role</th>
              <th>Status</th>
              <th>Joined</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} style={{ padding:40,textAlign:'center' }}><div className="spinner" style={{ margin:'0 auto' }}/></td></tr>
            ) : users.map(u => (
              <tr key={u.id}>
                <td>
                  <div style={{ display:'flex',alignItems:'center',gap:10 }}>
                    <div style={{ width:34,height:34,borderRadius:10,background:u.role==='admin'?'rgba(196,98,26,0.1)':'rgba(29,179,115,0.1)',color:u.role==='admin'?'var(--copper)':'var(--green-text)',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:12,flexShrink:0,fontFamily:'var(--font-display)' }}>
                      {initials(u.name)}
                    </div>
                    <div>
                      <div style={{ fontWeight:600,fontSize:13 }}>{u.name}</div>
                      {u.id===me.id && <div style={{ fontSize:10,color:'var(--copper)',fontFamily:'var(--font-mono)',letterSpacing:'0.08em' }}>YOU</div>}
                    </div>
                  </div>
                </td>
                <td style={{ color:'var(--mid)',fontSize:12 }}>{u.email}</td>
                <td>
                  <span style={{ display:'inline-flex',alignItems:'center',gap:5,padding:'3px 10px',borderRadius:99,background:u.role==='admin'?'rgba(196,98,26,0.1)':'rgba(29,179,115,0.1)',color:u.role==='admin'?'var(--copper)':'var(--green-text)',fontSize:11,fontWeight:600,fontFamily:'var(--font-mono)',letterSpacing:'0.04em' }}>
                    {u.role==='admin'?'⚡ Admin':'● Sales'}
                  </span>
                </td>
                <td>
                  <span style={{ display:'inline-flex',alignItems:'center',gap:5,padding:'3px 10px',borderRadius:99,background:u.active?'var(--green-bg)':'#F0EDE8',color:u.active?'var(--green-text)':'var(--muted)',fontSize:11,fontWeight:600 }}>
                    <span style={{ width:5,height:5,borderRadius:'50%',background:u.active?'var(--green)':'var(--ghost)',display:'inline-block' }}/>
                    {u.active?'Active':'Inactive'}
                  </span>
                </td>
                <td style={{ fontSize:12,color:'var(--muted)' }}>{new Date(u.created_at).toLocaleDateString('en-TT',{day:'2-digit',month:'short',year:'numeric'})}</td>
                <td>
                  <div className="gap-row" style={{ justifyContent:'flex-end' }}>
                    <button className="btn btn-outline btn-xs" onClick={()=>openEdit(u)}>Edit</button>
                    <button className="btn btn-outline btn-xs" onClick={()=>{ setPwModal(u); setNewPw(''); }}>Reset pw</button>
                    {u.id!==me.id && <button className={`btn btn-xs ${u.active?'btn-danger':'btn-outline'}`} onClick={()=>toggleActive(u)}>{u.active?'Deactivate':'Activate'}</button>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop:18,background:'rgba(196,98,26,0.06)',border:'1px solid rgba(196,98,26,0.15)',borderRadius:12,padding:'12px 18px',fontSize:13,color:'var(--mid)',display:'flex',gap:16 }}>
        <span><strong style={{ color:'var(--copper)' }}>⚡ Admin</strong> — manages rates, users, all quotes and settings</span>
        <span><strong style={{ color:'var(--green-text)' }}>● Sales</strong> — creates quotes and manages clients</span>
      </div>

      {modal && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <div className="modal-title">{editing?'Edit user':'Add new user'}</div>
            </div>
            <div className="modal-body">
              <div className="field-row">
                <div className="field"><label className="label">Full name <span className="req">*</span></label><input className="input" value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="Jane Smith" autoFocus/></div>
                <div className="field"><label className="label">Role</label>
                  <select className="select" value={form.role} onChange={e=>setForm(f=>({...f,role:e.target.value}))}>
                    <option value="sales">Sales</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
              </div>
              <div className="field"><label className="label">Email <span className="req">*</span></label><input className="input" type="email" value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} placeholder="jane@pastrinidad.com"/></div>
              <div className="field"><label className="label">{editing?'New password (leave blank to keep)':'Password *'}</label><input className="input" type="password" value={form.password} onChange={e=>setForm(f=>({...f,password:e.target.value}))} placeholder={editing?'Leave blank to keep current':'Min. 6 characters'}/></div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-outline" onClick={()=>setModal(false)}>Cancel</button>
              <button className="btn btn-copper" onClick={save} disabled={saving}>{saving?'Saving…':editing?'Save changes':'Create user'}</button>
            </div>
          </div>
        </div>
      )}

      {pwModal && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setPwModal(null)}>
          <div className="modal" style={{ width:380 }}>
            <div className="modal-header"><div className="modal-title">Reset password</div><div className="modal-subtitle">For {pwModal.name}</div></div>
            <div className="modal-body">
              <div className="field"><label className="label">New password</label><input className="input" type="password" value={newPw} onChange={e=>setNewPw(e.target.value)} placeholder="Min. 6 characters" autoFocus/></div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-outline" onClick={()=>setPwModal(null)}>Cancel</button>
              <button className="btn btn-primary" onClick={resetPw}>Reset password</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
